<template>
  <a-card :bordered="false" title="短信订单" :headStyle="{fontSize:'18px'}">
    <custom-page-table
      ref="table"
      :queryParams="queryParams"
      :columns="columns"
      base-key="smsUrl"
      params-path="sms/getSmsOrderList"
    >
    <span slot="index" slot-scope="rowItem">
      {{ rowItem.index + 1 }}
    </span>
    </custom-page-table>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'SmsOrderList',
  mixins: [searchForm],
  data() {
    return {
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '订单号',
          dataIndex: 'orderNo'
        },
        {
          title: '来源渠道',
          dataIndex: 'platformName'
        },
        {
          title: '所属运营商',
          dataIndex: 'merchantName'
        },
        {
          title: '联系人',
          dataIndex: 'merchantContact'
        },
        {
          title: '联系人电话',
          dataIndex: 'merchantMobile'
        },
        {
          title: '金额',
          dataIndex: 'amount'
        },
        {
          title: '短信条数',
          dataIndex: 'smsNum'
        },
        {
          title: '充值时间',
          dataIndex: 'createTime'
        }
      ],
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId
    }
  },
  mounted() {
  },
  methods: {}

}
</script>
<style scoped>
</style>